import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-enterprise/base.css'
import '@inovua/reactdatagrid-enterprise/theme/default-light.css'
import Drawer from '../Drawer/Drawer.js';
import moment from 'moment';
import { toggleDrawer } from '../../helpers/helpers.js';
import { isAuthorized } from '@smarterservices/iam-react-client';

const CheckoutQueue = observer(class CheckoutQueue extends React.Component {
  constructor() {
    super();
    this.renderDisconnectReason = this.renderDisconnectReason.bind(this);
    this.renderCheckoutButton = this.renderCheckoutButton.bind(this);
    this.loadData = this.loadData.bind(this);

    this.state = {
      drawerOpen: false,
      selectedSession: '',
      limit: 0,
      offset: 0
    };
  }

  componentDidMount() {
    const iam = sessionStorage.getItem('iam');
    const { proctorAccountSid } = this.props.store.SessionStore.userData;

    if (!isAuthorized('sp:DescribeCheckoutQueue', `ssrn:ss:sp::${proctorAccountSid}:checkoutQueue`, iam)) {
      this.props.routing.history.push('/unauthorized');
    }
  }

  renderDisconnectReason({data}) {
    switch(data.disconnectReasonId) {
      case 'test-taker-ended':
        return 'Completed successfully';

      case 'proctor-ended':
        return 'Removed from testing session';

      case 'internet-disconnected':
        return 'Internet disconnected';

      default:
        return 'Unknown';
    }
  }

  renderCheckoutButton(data) {
    const { translation } = this.props;
    const sessionSid = data.sid;
    return (
        <span className='data-grid--center'>
          <button
              className='btn'
              onClick={() => {
                toggleDrawer(null, this, 'Checkout');
                this.setState({ selectedSession: sessionSid });
              }}
          >
            {translation.checkout}
          </button>
        </span>
    );
  }

  loadData({skip, limit}) {
    const { HybridStore } = this.props.store;

    if (!skip) skip = this.state.offset;
    if (!limit) limit = this.state.limit

    this.setState({limit, offset: skip});

    return HybridStore.listCheckoutSessions(limit, skip, true)
      .then(response => {
        return {data: response.results, count: response.total};
      })
  }

  refreshData() {
    // This changes the instance of the function loadData which means a new prop
    // gets passed to the data grid triggering a refresh of the list
    this.loadData = this.loadData.bind(this);
  }

  render() {
    const { translation } = this.props;
    const { drawerOpen, selectedSession } = this.state;

    const gridStyle = { minHeight: 500, maxHeight:2000 };
    const columns = [
      {
        name: 'appointmentDate',
        header: 'Session Date',
        defaultFlex: 1,
        render: ({data}) => moment(data.appointmentDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')
      },
      {
        name: 'name',
        header: 'Name',
        type: 'string',
        defaultFlex: 1,
        render: ({ data }) => {
          return <span>{`${data.enrollment.firstName} ${data.enrollment.lastName}`}</span>;
        }
      },
      {
        name: 'disconnectReasonId',
        header: 'End Reason',
        defaultFlex: 1,
        render: (data) => this.renderDisconnectReason(data)
      },
      // {
      //   name: 'sessionLength',
      //   header: 'Duration'
      // },
      {
        name: 'autoFlags',
        header: 'AI Flags',
        render: ({ data }) => {
          return <span className='data-grid--center'>{data.annotationCounts.system}</span>;
        }
      },
      {
        name: 'manualFlags',
        header: 'Proctor Flags',
        render: ({ data }) => {
          return <span className='data-grid--center'>{data.annotationCounts.manual}</span>;
        }
      },
      {
        name: 'checkout',
        header: 'Checkout',
        defaultFlex: 1,
        render: ({ data }) => this.renderCheckoutButton(data)
      },
    ];

    return (
      <main tabIndex="0" id="main-content" className="page fill">
        <div className="fill">
          <h1>{translation.heading}</h1>

          <ReactDataGrid
            className="reactDataGrid fill"
            style={gridStyle}
            idProperty="id"
            columns={columns}
            dataSource={this.loadData}
            //defaultFilterValue={filterValue}
            //onFilterValueChange={setFilterObject}
            //onSkipChange={setSkip}
            //onLimitChange={setLimit}
            //limit={limit}
            //skip={skip}
            //onRowClick={onRowClick}
            pagination={true}
          />

          {drawerOpen &&
            <Drawer
              content='Checkout'
              large
              isOpen={drawerOpen}
              parent={this}
              sessionSid={selectedSession}
              refreshList={() => this.refreshData()}
              {...this.props}
            />
          }
        </div>


      </main>
    )
  }
});

export default translate('CheckoutQueue')(CheckoutQueue);


// WEBPACK FOOTER //
// ./src/app/components/Checkout/CheckoutQueue.js